import { StatusBar, Style } from '@capacitor/status-bar'
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support'

export const setStatusBarStyleDark = async (platform: string) => {
  if (platform === 'android') {
    // 2025年9月時点で、CapacitorのStatusBarプラグインでは、Android15以降のStatusBar背景色の変更をサポートしていない
    // EdgeToEdgeプラグインを使用して背景色を変更する
    await EdgeToEdge.setBackgroundColor({ color: '#000000' }).catch(e => {
      // catch error not support platform
    })
  }
  await StatusBar.setStyle({ style: Style.Dark }).catch(e => {
    //TODO catch error not support platform
  })
}

export const setStatusBarStyleLight = async (platform: string) => {
  if (platform === 'android') {
    // 2025年9月時点で、CapacitorのStatusBarプラグインでは、Android15以降のStatusBar背景色の変更をサポートしていない
    // EdgeToEdgeプラグインを使用して背景色を変更する
    await EdgeToEdge.setBackgroundColor({ color: '#ffffff' }).catch(e => {
      // catch error not support platform
    })
  }
  await StatusBar.setStyle({ style: Style.Light }).catch(e => {
    //TODO catch error not support platform
  })
}

export const setStatusBarStyle = (platform: string, isDark: boolean) => {
  return isDark
    ? setStatusBarStyleDark(platform)
    : setStatusBarStyleLight(platform)
}
